import { theme } from '@ublend-npm/aulaui-next';
import fonts from '../../../styles/fonts';

const height =
  window.innerHeight ||
  document.documentElement.clientHeight ||
  document.body.clientHeight;
const containerHeight = 514;
const topMargin = (height - containerHeight - 80) / 2;
const topMarginWithHeader = topMargin < 0 ? 90 : topMargin + 80;

export default {
  greyBackground: {
    backgroundColor: theme.color.grayLight,
    width: '100%',
    height,
  },
  background: {
    width: '100%',
    height,
    backgroundColor: theme.color.grayLight,
    position: 'absolute',
    fontSize: 15,
    overflow: 'scroll',
  },
  container: {
    margin: `${topMarginWithHeader}px auto`,
    width: 400,
    padding: 50,
    boxSizing: 'border-box',
    height: containerHeight,
    borderRadius: '3px',
    backgroundColor: '#ffffff',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.3)',
  },
  title: {
    ...fonts.regular,
    fontSize: 22,
  },
  message: {
    marginTop: 20,
    ...fonts.regular,
  },
  subHeader: {
    ...fonts.regular,
    marginTop: 20,
  },
  browserList: {
    marginTop: 17,
  },
  browser: {
    display: 'block',
    textDecoration: 'none',
    color: theme.color.designSystem.purple70,
    ...fonts.bold,
    marginTop: 25,
  },
  whyNot: {
    textDecoration: 'none',
    color: theme.color.designSystem.purple70,
    ...fonts.regular,
  },
  browserImage: {},
  browserName: {
    marginTop: -32,
    marginLeft: 52,
  },
};
